import { createFileRoute } from '@tanstack/react-router';
import { TenantDetail } from '@/screens/RAdmin/Tenants/TenantDetail';

export const Route = createFileRoute('/radiant/tenants/$id')({
  component: TenantDetail,
});
